import React, {useContext, useEffect, useRef} from 'react'
import styles from './QA.scss'
import {RouterContext} from '../../containers/Context'

export const qaList = [
  [
    ' どのエリアに対応していますか？',
    <>
      <span className={styles.otherFont}>Carstay</span>は日本全国のどこでも駐車場・観光体験を掲載できます。年1日からの掲載が可能です。
    </>
  ],

  [
    '駐車場・観光体験の料金はどうやって決まりますか？',
    '基本的にホストご自身で設定可能です。料金は随時変更も可能です。',
  ],

  [
    'ホスト登録するにあたって何か費用は発生しますか？',
    '初期登録にあたり、サービス掲載・翻訳・プロモーション等にかかる費用は一切かかりません。',
  ],

  [
    '報酬はどのように計算されますか？',
    <>
      基本料金と追加料金の合計額から、当該金額に手数料率を乗じた販売手数料を差し引いた金額が報酬です。<br/>
      例えば、<span className={styles.otherFont}>1</span>台<span className={styles.otherFont}>2000</span>円 + ゴミ袋
      <span className={styles.otherFont}>500</span>円 の場合は、
      手数料<span className={styles.otherFont}>1000</span>円<span className={styles.otherFont}>(2500×40%)</span>
      を引いた<span className={styles.otherFont}>1500</span>円が報酬になります。<br/>
      手数料は、駐車場は<span className={styles.otherFont}>40%</span>、キャンプ場は<span className={styles.otherFont}>20%</span>、体験は<span className={styles.otherFont}>15%</span>です。<br/>
      テント泊と調理が可能であればキャンプ場、そうでない場合は駐車場での登録になります。<br/>
    </>
  ],

  [
    'どんなゲストが駐車場の利用や観光体験に参加するか事前に知ることはできますか？',
    <>
      ゲストの名前・国籍・人数・利用時間等の必要な情報は予約時点にホストさまにメールでお送りします。<br/>また、管理画面から常に、予約情報や収入情報について、確認することができます。
    </>
  ],

  [
    'ホスト登録が完了した場合、予約が入った際に何か必要な手続きはありますか？',
    <>
      ホスト登録が完了すると、弊社が駐車台数分のロードコーン
      <span className={styles.otherFont}>「Carstay</span>コーン」を送付いたします。<br/>ゲスト予約が入りましたら、受渡可能なスペースに目印となる
      <span className={styles.otherFont}>「Carstay</span>コーン」の設置をお願いします。
    </>
  ],

  [
    'ゲストが騒音やゴミの違法廃棄等の問題を起こさないような防止施策をどのように立てていますか？',
    'ゲストの利用規約や予約メールに迷惑行為を禁止する内容を明記し、注意喚起を徹底しております。'
  ],

  [
    '報酬はいつ振り込まれますか？',
    <>
      基本的に、月末締め、翌月末にお振込にてお支払いします。振込手数料を弊社で負担するため、<br className='d-none d-md-block'/>
      報酬が<span className={styles.otherFont}>10,000</span>円(税込)に達してからのお振込となります。<span className={styles.otherFont}>10,000</span>円に達していない場合、次月繰越となります。
    </>
  ],
]

const QA = () => {
  const qaRef = useRef()
  const {location} = useContext(RouterContext)!
  useEffect(() => {
    if (location?.hash === '#qa') {
      const targetQa = qaRef
      if (!targetQa) return
      window.scrollTo({
        top: window.pageYOffset,
        behavior: 'smooth',
      })
    }
  }, [location])
  return　<div className={['w-100', styles.container].join(' ')} id="qa">
    <div className={styles.space120}/>
    <div className="w-100 d-flex flex-column align-items-center p-0">
    <div className={['text-center', styles.subTitle].join(' ')}>よくあるご質問</div>
    <div className={[styles.rounded, styles.list].join(' ')}>
      {qaList.map(([question, answer], index) => <div
        key={index}
        ref={index === 7 ? qaRef : undefined}
        className={[index && 'border-top', styles.listView, index === 0 ? styles.firstItem : '', index === 3 ? styles.itemQ4 : '', index === 2 ? styles.itemQ3 : ''].filter(Boolean).join(' ')}>
        <div className="d-flex">
          <div className={styles.textQuestion}>
            <span style={{marginRight: index === 0 ? 1 : 0}} className={[styles.fw7].join(' ')}>Q{index + 1} </span>
            {question}
          </div>
        </div>
        <div className="d-flex">
          <div className={styles.textAnswer}>{answer}</div>
        </div>
      </div>)}
    </div>
    </div>
    <div className={styles.space120}/>
  </div>
}
QA.displayName = 'QA'
export default QA
